import React from 'react'

const ChevronDownIcon = props => (
  <svg
    className={props.className}
    viewBox="0 0 52 29"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polyline
      transform="rotate(90 567.041 206.021)"
      points="363.0205 722.9795 387.0625 747.0215 363.0205 771.0625"
      strokeWidth="3"
      stroke="#50B9DC"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
)

export default ChevronDownIcon
